import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
 
import { UserLoginService } from '../userlogin.service';

@Component({
  selector: 'app-society-signup',
  templateUrl: './society-signup.component.html',
  styleUrls: ['./society-signup.component.css']
})
export class SocietySignupComponent {
   signupForm!: FormGroup;
  otpSent = false;
  otpVerified = false;
  otpTimer = 60;
 
  private timerSub?: Subscription;
 
  constructor(
    private fb: FormBuilder,
    private userLoginService: UserLoginService,
    private router: Router,
    private toastr: ToastrService
  ) {}
 
  ngOnInit(): void {
    this.signupForm = this.fb.group(
      {
        // Personal
        firstName:    ['', Validators.required],
        lastName:     ['', Validators.required],
        email:        ['', [Validators.required, Validators.email]],
        mobileNumber: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
 
        // Society-specific
        flatNumber: ['', Validators.required],
        wing:       [''],
 
        // Security
        username:        ['', Validators.required],
        password:        ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
        otp:             ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      },
      { validators: this.passwordMatchValidator }
    );
  }
 
  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
  }
 
  // ── Validators ──────────────────────────────────────────────────────────────
  private passwordMatchValidator(group: FormGroup) {
    const pw  = group.get('password')?.value;
    const cpw = group.get('confirmPassword')?.value;
    return pw === cpw ? null : { mismatch: true };
  }
 
  // ── OTP ─────────────────────────────────────────────────────────────────────
  sendOtp(): void {
    const mobile = this.signupForm.get('mobileNumber');
    if (!mobile?.valid) {
      mobile?.markAsTouched();
      return;
    }
 
    // Call your OTP service here
    // this.userLoginService.UserLogin_LoginGenerateOtp({ mobileNo: mobile.value }).subscribe(...)
 
    this.otpSent = true;
    this.toastr.info(`OTP sent to ${mobile.value}`);
    this.startTimer();
  }
 
  private startTimer(): void {
    this.otpTimer = 60;
    this.timerSub?.unsubscribe();
    this.timerSub = interval(1000)
      .pipe(takeWhile(() => this.otpTimer > 0))
      .subscribe(() => this.otpTimer--);
  }
 
  // ── Submit ───────────────────────────────────────────────────────────────────
  onSubmit(): void {
    this.markAllTouched(this.signupForm);
    if (this.signupForm.invalid) return;
 
    this.userLoginService.UserLogin_Create(this.signupForm.value as any).subscribe({
      next: () => {
        this.toastr.success('Account created successfully! Please log in.', 'Welcome');
        this.router.navigate(['/login']);
      },
      error: (err: any) => {
        console.error('Registration failed', err);
        this.toastr.error('Registration failed. Please try again.', 'Error');
      },
    });
  }
 
  private markAllTouched(group: FormGroup): void {
    Object.values(group.controls).forEach((ctrl) => {
      ctrl.markAsTouched();
      if ((ctrl as FormGroup).controls) {
        this.markAllTouched(ctrl as FormGroup);
      }
    });
  }
}
